import React from 'react';
import iconMarketing from '../assets/images/marketing.png';
import iconUA from '../assets/images/ua.svg';
import iconStyle from '../assets/images/style.png';
import iconEficaz from '../assets/images/eficaz.png';
import iconNanonino from '../assets/images/nanonino.png';
import iconWork from '../assets/images/work.svg';
import iconCommunication from '../assets/images/communication.svg';
import iconConflict from '../assets/images/conflict.svg';
import iconLider from '../assets/images/lider.svg';
import iconNegoc from '../assets/images/negoc.svg';
import iconTime from '../assets/images/time.svg';
import iconConsultimg from '../assets/images/expconsultimg.png';
import iconXummum from '../assets/images/expxummum.png';
import iconUmp from '../assets/images/expump.png';
import iconUmmore from '../assets/images/expummore.png';
import iconEficaze from '../assets/images/expeficaz.png';
import iconTuperchero from '../assets/images/exptuperchero.png';
import iconNanoninoe from '../assets/images/expnanonino.png';
import iconBemod from '../assets/images/expbemod.png';
import iconAlavista from '../assets/images/expalavista.png';
import iconStylee from '../assets/images/expstyle.png';
import iconFeroz from '../assets/images/expferoz.png';

const DownloadButton = () => {
    const buttonStyle = {
        borderRadius: '8px',
        padding: '15px 25px',
        backgroundColor: '#454545',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        display: 'inline-block'
    };

    const hoverStyle = {
        backgroundColor: '#ccc'
    };

    return (
        <a
            href="/Cartas_Recomendacion_Paola_Valle.pdf"
            download
            style={buttonStyle}
            onMouseEnter={(e) => e.target.style.backgroundColor = hoverStyle.backgroundColor}
            onMouseLeave={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
        >
            Descargar
        </a>
    );
};

function Services() {
    const containerStyle = {
        textAlign: 'center',
        marginBottom: '20px'
    };

    const iconsContainerStyle = {
        textAlign: 'center',
        marginTop: '40px'
    };

    return (
        <article className="content active" data-page="resume">
            <header>
                <h2 className="h2 article-title">Experiencia</h2>
            </header>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconFeroz} alt="icono Productividad Feroz" width="40" />
                    </div>
                    <h3 className="h3">Productividad Feroz</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Community Manager</h4>
                        <span>2024</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconUmmore} alt="icono Ummore" width="40" />
                    </div>
                    <h3 className="h3">Ummore Talenting</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Project Manager</h4>
                        <span>2024</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconAlavista} alt="icono Alavista" width="40" />
                    </div>
                    <h3 className="h3">Agencia de Marketing Alavista</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Project Manager</h4>
                        <span>2024</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconXummum} alt="icono Xummum" width="40" />
                    </div>
                    <h3 className="h3">Xummum</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Project Manager</h4>
                        <span>2023</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconUmp} alt="icono Universidad Americana de Paraguay" width="40" />
                    </div>
                    <h3 className="h3">Universidad Americana de Paraguay</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Consultora de imagen</h4>
                        <span>2023</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconNanoninoe} alt="icono Nanonino" width="40" />
                    </div>
                    <h3 className="h3">Nanonino</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Community Manager</h4>
                        <span>2023</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconTuperchero} alt="icono Tu Perchero" width="40" />
                    </div>
                    <h3 className="h3">Tu Perchero</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Project Manager | Creadora de Contenido | Comercial</h4>
                        <span>2023</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconBemod} alt="icono Be Models" width="40" />
                    </div>
                    <h3 className="h3">Be Models</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Consultora de Imagen | Organización de Eventos</h4>
                        <span>2022</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconEficaze} alt="icono Eficaz Publicidad Digital" width="40" />
                    </div>
                    <h3 className="h3">Eficaz Publicidad Digital</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Community Manager</h4>
                        <span>2022</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconConsultimg} alt="icono Consultora de Imagen" width="40" />
                    </div>
                    <h3 className="h3">Consultora de Imagen</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Consultora de Imagen | Influencer Marketing</h4>
                        <span>2020</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconStylee} alt="icono StyleInnovators" width="40" />
                    </div>
                    <h3 className="h3">StyleInnovators</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">Consultora de imagen</h4>
                        <span>2024</span>
                        {/* <p className="timeline-text">📌 Descripción</p> */}
                    </li>
                </ol>
            </section>

            <section className="skill">
                <h3 className="h3 skills-title">Referencias</h3>
                <div style={iconsContainerStyle}>
                    <ul className="skills-list content-card">
                        <li>
                            <img
                                src={iconUA}
                                alt="icono Universidad de Alicante"
                                width="40"
                                style={{ borderRadius: '10%' }}
                            />
                        </li>
                        <li>
                            <img src={iconNanonino} alt="icono Nanonino" width="40" />
                        </li>
                        <li>
                            <img src={iconStyle} alt="icono Styleinnovators" width="40" />
                        </li>
                        <li>
                            <img src={iconEficaz} alt="icono Eficaz Publicidad Digital" width="40" />
                        </li>
                    </ul>
                </div>
                <br />
                <div style={containerStyle}>
                    <DownloadButton />
                </div>
            </section>

            <section className="blog-posts">
                <br /><br />
                <h3 className="h3 skills-title">Habilidades</h3>
                <br />
                <ul className="testimonials-list has-scrollbar">
                    <li className="testimonials-item">
                        <div className="content-card" data-testimonials-item>
                            <figure className="testimonials-avatar-box">
                                <img src={iconCommunication} alt="icono comunicación" width="40" />
                            </figure>
                            <h4 className="h4 testimonials-item-title" data-testimonials-title>Comunicación</h4>
                            <div className="testimonials-text" data-testimonials-text>
                                <p>◉◉◉◉◉◉◉◉○</p>
                            </div>
                        </div>
                    </li>
                    <li className="testimonials-item">
                        <div className="content-card" data-testimonials-item>
                            <figure className="testimonials-avatar-box">
                                <img src={iconLider} alt="icono liderazgo" width="40" />
                            </figure>
                            <h4 className="h4 testimonials-item-title" data-testimonials-title>Liderazgo</h4>
                            <div className="testimonials-text" data-testimonials-text>
                                <p>◉◉◉◉◉◉◉○○</p>
                            </div>
                        </div>
                    </li>
                    <li className="testimonials-item">
                        <div className="content-card" data-testimonials-item>
                            <figure className="testimonials-avatar-box">
                                <img src={iconTime} alt="icono gestión del tiempo" width="40" />
                            </figure>
                            <h4 className="h4 testimonials-item-title" data-testimonials-title>Gestión del tiempo</h4>
                            <div className="testimonials-text" data-testimonials-text>
                                <p>◉◉◉◉◉◉○○○</p>
                            </div>
                        </div>
                    </li>
                    <li className="testimonials-item">
                        <div className="content-card" data-testimonials-item>
                            <figure className="testimonials-avatar-box">
                                <img src={iconWork} alt="icono trabajo en equipo" width="40" />
                            </figure>
                            <h4 className="h4 testimonials-item-title" data-testimonials-title>Trabajo en equipo</h4>
                            <div className="testimonials-text" data-testimonials-text>
                                <p>◉◉◉◉◉◉◉◉○</p>
                            </div>
                        </div>
                    </li>
                    <li className="testimonials-item">
                        <div className="content-card" data-testimonials-item>
                            <figure className="testimonials-avatar-box">
                                <img src={iconNegoc} alt="icono negociación" width="40" />
                            </figure>
                            <h4 className="h4 testimonials-item-title" data-testimonials-title>Negociación</h4>
                            <div className="testimonials-text" data-testimonials-text>
                                <p>◉◉◉◉◉◉◉◉○</p>
                            </div>
                        </div>
                    </li>
                    <li className="testimonials-item">
                        <div className="content-card" data-testimonials-item>
                            <figure className="testimonials-avatar-box">
                                <img src={iconConflict} alt="icono gestión de conflictos" width="40" />
                            </figure>
                            <h4 className="h4 testimonials-item-title" data-testimonials-title>Gestión de conflictos</h4>
                            <div className="testimonials-text" data-testimonials-text>
                                <p>◉◉◉◉◉◉◉◉◉</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </section>
        </article>
    );
}

export default Services;
